import React from 'react'
import Page from 'component/page-container'
import Process from 'component/process'
import { HashLink } from 'react-router-hash-link';

import './style.css'

/* global API */

const ProcessRoute = props => {
    const [processes, setProcesses] = React.useState([])
    React.useEffect(() => {
        API.instance().getProcessList().then(setProcesses)
    }, [])

    return (
        <Page className="index-page" h1="Процессы">
            <div className="page__inner">
                <div className="container">
                    <p>Чтобы присоединиться к процессу, напишите кому-то из его администраторов.</p>
                    <p>Не стесняйтесь <HashLink to="/bots#process_club_bot">создавать собственные процессы</HashLink>.</p>
                </div>
                <div className="process-list">
                    {processes.map(process => (
                        <Process key={process.id} process={process} />
                    ))}
                </div>
            </div>
        </Page>
    )
}

export default ProcessRoute
